<mat-toolbar class="topbar flex mat-bg-card">
  <!-- Sidenav toggle button -->
  <button
    *ngIf="layoutConf.sidebarStyle !== 'compact'"
    mat-icon-button
    id="sidenavToggle"
    (click)="toggleSidenav()"
    matTooltip="Toggle Hide/Open"
  >
    <mat-icon>menu</mat-icon>
  </button>
  <a (click)="goToHome()">
    <img
      width="150px"
      style="padding-top: 5px"
      src="assets/images/logos/en-01.png"
      alt=""
  /></a>

  <span class="flex-grow"></span>

  <button mat-icon-button [matMenuTriggerFor]="accountMenu" class="">
    <img src="{{imgProfile}}" alt="" class="!w-6 !h-6 rounded-full" />
  </button>

  <mat-menu #accountMenu="matMenu" class="!p-0">
    <div
      class="w-64 flex flex-col items-center justify-center mx-0 my-4 p-0 rounded-none !shadow-none"
      style="box-shadow: none"
    >
      <mat-card-content class="flex flex-col items-center justify-center p-0">
        <img
          src="{{imgProfile}}"
          alt=""
          class="w-20 h-20 rounded-full text-center"
        />
        <h5 class="mt-2 text-center">{{username}}</h5>
      </mat-card-content>
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="profile()">
      <mat-icon>manage_accounts</mat-icon>
      <span>Profile</span>
    </button>
    <button mat-menu-item (click)="changePasswordWithKeyCloak()">
      <mat-icon>lock</mat-icon>
      <span>Change Password</span>
    </button>
    <button (click)="logOut()" mat-menu-item>
      <mat-icon>power_settings_new</mat-icon>
      <span>Sign Out</span>
    </button>
  </mat-menu>
</mat-toolbar>
